import React, { createContext, useRef, useContext, useState, useCallback } from "react";
import { ITopMedScheduleContext, ITopMedScheduleContextProviderProps } from "./models";
import { IPhysician } from "../../../models/topmed";

const topMedScheduleContext = createContext<ITopMedScheduleContext>({
  physicians: [],
  loading: false,
  registered: false,
  scheduleDates: [],
  lastBatchRef: { current: null },
  onFetchPhysicians: () => {},
  onFetchScheduleDates: () => {},
  onLoading: () => {},
  onRegistered: () => {},
});

export const TopMedScheduleContextProvider: React.FC<ITopMedScheduleContextProviderProps> = ({ children }) => {
  const [physicians, setPhysicians] = useState<IPhysician[]>([]);
  const [scheduleDates, setScheduleDates] = useState<string[]>([]);
  const lastBatchRef = useRef<{ month: number; specialty: number } | null>(null);
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);

  const onFetchPhysicians = useCallback((value: IPhysician[]) => {
    setPhysicians(value);
  }, []);

  const onFetchScheduleDates = useCallback((value: string[]) => {
    setScheduleDates(value);
  }, []);

  const onLoading = useCallback((value: boolean) => {
    setLoading(value);
  }, []);

  const onRegistered = useCallback(() => {
    setRegistered(true);
  }, []);

  return (
    <topMedScheduleContext.Provider
      value={{
        physicians,
        loading,
        registered,
        scheduleDates,
        lastBatchRef,
        onFetchPhysicians,
        onFetchScheduleDates,
        onLoading,
        onRegistered,
      }}
    >
      {children}
    </topMedScheduleContext.Provider>
  );
};

export const useTopMedSchedule = () => {
  return useContext(topMedScheduleContext);
};
